import { NavLink, Outlet } from 'react-router-dom';
import { Container, Content, Navbar } from './style';
import Logo from '../../assets/icons/logo.svg?react';

const AuthLayout = () => {
  return (
    <Container>
      <Navbar>
        <NavLink to="/">
          <Logo />
        </NavLink>
      </Navbar>
      <Content>
        <Outlet />
      </Content>
    </Container>
  );
};

export default AuthLayout;
